import {reporter} from 'common/report/error-reporting';

const QUERY_API_ROOT = `/api/query/`;
let queryApiRequests: Array<{
  url: string;
  stack?: string;
}> = [];

export function trackQueryApiFetch(url: string) {
  if (!url.startsWith(QUERY_API_ROOT)) {
    return;
  }
  queryApiRequests = [
    ...queryApiRequests.slice(-9),
    {
      url,
      stack: new Error().stack,
    },
  ];
}

export function reportQueryApiRequestsToWrongRegion({
  redirectRegion,
  reactive,
}: {
  redirectRegion: string;
  reactive: boolean;
}) {
  if (!queryApiRequests.length) {
    return;
  }
  reporter.warn(`query-api requests initiated in wrong region`, {
    reactive,
    correctRegion: redirectRegion,
    requests: JSON.stringify(queryApiRequests),
  });
}
